var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "signup-wrapper",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onEnter.apply(null, arguments)
        },
      },
    },
    [
      _vm.state === "resume_notice"
        ? _c(
            "div",
            { staticClass: "signup-card text-center" },
            [
              _c("feather-icon", {
                staticClass: "h-12 w-12 text-primary mb-2",
                attrs: { icon: "MailIcon" },
              }),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("signup_wizard.lead.resume_title"))),
              ]),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("signup_wizard.lead.resume_text"))),
              ]),
            ],
            1
          )
        : _vm.state === "account_notice"
        ? _c(
            "div",
            { staticClass: "signup-card text-center" },
            [
              _c("feather-icon", {
                staticClass: "h-12 w-12 text-primary mb-2",
                attrs: { icon: "MailIcon" },
              }),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("signup_wizard.lead.account_title"))),
              ]),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("signup_wizard.lead.account_text"))),
              ]),
              _c(
                "b-button",
                {
                  staticClass: "mt-1",
                  attrs: { variant: "outline-primary", to: "/login" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("signup_wizard.lead.email_in_use_login")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm.state === "invalid_token"
        ? _c(
            "div",
            { staticClass: "signup-card text-center" },
            [
              _c("feather-icon", {
                staticClass: "h-12 w-12 text-warning mb-2",
                attrs: { icon: "AlertTriangleIcon" },
              }),
              _c("h3", [_vm._v(_vm._s(_vm.$t("signup_wizard.invalid.title")))]),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("signup_wizard.invalid.text"))),
              ]),
              !_vm.resendSent
                ? [
                    _c(
                      "b-form-group",
                      {
                        staticClass: "text-left mt-2",
                        attrs: { label: _vm.$t("signup_wizard.invalid.email") },
                      },
                      [
                        _c("b-form-input", {
                          attrs: { type: "email" },
                          model: {
                            value: _vm.resendEmail,
                            callback: function ($$v) {
                              _vm.resendEmail = $$v
                            },
                            expression: "resendEmail",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "w-full",
                        attrs: {
                          variant: "primary",
                          disabled: _vm.busy || !_vm.resendEmail,
                        },
                        on: { click: _vm.resend },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("signup_wizard.invalid.resend")) +
                            " "
                        ),
                      ]
                    ),
                  ]
                : _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mt-2",
                      attrs: { variant: "success", show: "" },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("signup_wizard.invalid.sent"))),
                      ]),
                    ]
                  ),
              _c(
                "b-button",
                {
                  staticClass: "w-full mt-1",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.startOver },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("signup_wizard.invalid.start_over")) +
                      " "
                  ),
                ]
              ),
              _c("recaptcha-notice"),
            ],
            2
          )
        : _vm.state === "success"
        ? _c(
            "div",
            { staticClass: "signup-card text-center" },
            [
              _c("feather-icon", {
                staticClass: "h-12 w-12 text-success mb-2",
                attrs: { icon: "CheckCircleIcon" },
              }),
              _c("h3", [_vm._v(_vm._s(_vm.$t("signup_wizard.success.title")))]),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.$t("signup_wizard.success.text"))),
              ]),
              _c(
                "ol",
                { staticClass: "text-left text-muted signup-success-steps" },
                [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("signup_wizard.success.next_review"))),
                  ]),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("signup_wizard.success.next_email"))),
                  ]),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("signup_wizard.success.next_login"))),
                  ]),
                ]
              ),
              _c(
                "b-button",
                {
                  staticClass: "w-full mt-2",
                  attrs: { variant: "primary", to: "/login" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("signup_wizard.success.login")) + " "
                  ),
                ]
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "signup-card" },
            [
              _c("h2", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.$t("signup_wizard.title"))),
              ]),
              _c("p", { staticClass: "text-muted mb-2" }, [
                _vm._v(_vm._s(_vm.$t("signup_wizard.subtitle"))),
              ]),
              _vm.serverAlert
                ? _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: { variant: "danger", show: "" },
                    },
                    [_c("small", [_vm._v(_vm._s(_vm.serverAlert))])]
                  )
                : _vm._e(),
              _vm.emailNotice
                ? _c(
                    "b-alert",
                    {
                      staticClass: "p-1 mb-2",
                      attrs: { variant: "info", show: "" },
                    },
                    [
                      _c("small", [
                        _vm._v(_vm._s(_vm.$t("signup_wizard.lead.email_sent"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "validation-observer",
                { ref: "observer" },
                [
                  _c(
                    "wizard-shell",
                    {
                      attrs: {
                        steps: _vm.shellSteps,
                        current: _vm.current,
                        doneKeys: _vm.doneSteps,
                        nextDisabled: _vm.nextDisabled,
                        nextLabel:
                          _vm.current === "lead" && !_vm.token
                            ? _vm.$t("signup_wizard.lead.start")
                            : null,
                        busy: _vm.busy,
                      },
                      on: { prev: _vm.prev, next: _vm.next, goto: _vm.go },
                      scopedSlots: _vm._u([
                        {
                          key: "footer-info",
                          fn: function () {
                            return [
                              _vm.savedAt
                                ? _c(
                                    "small",
                                    { staticClass: "text-success" },
                                    [
                                      _c("feather-icon", {
                                        attrs: {
                                          icon: "CheckIcon",
                                          svgClasses: "w-3 h-3",
                                        },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("signup_wizard.saved")
                                          ) +
                                          " "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm.token
                                ? _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("signup_wizard.resume_hint")
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("div", { ref: "stepBody" }, [
                        _vm.current === "lead"
                          ? _c(
                              "div",
                              { key: "step-lead" },
                              [
                                _c("label", { staticClass: "d-block mb-1" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("signup_wizard.lead.type_label")
                                    )
                                  ),
                                ]),
                                _c("choice-cards", {
                                  attrs: {
                                    options: _vm.typeOptions,
                                    disabled: !!_vm.token,
                                  },
                                  model: {
                                    value: _vm.model.lead.person_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.model.lead,
                                        "person_type",
                                        $$v
                                      )
                                    },
                                    expression: "model.lead.person_type",
                                  },
                                }),
                                _c("div", { staticClass: "vx-row mt-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/2 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.lead.name_label"
                                          ),
                                          vid: "name",
                                          rules: "required|min:3",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.lead.name_label"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        ref: "lead_name",
                                                        attrs: {
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.lead.name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.lead,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.lead.name",
                                                        },
                                                      }),
                                                      _vm.isEstablishment
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "signup_wizard.lead.name_hint_le"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1498678765
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/2 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.lead.email_label"
                                          ),
                                          vid: "email",
                                          rules: "required|email",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.lead.email_label"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: "email",
                                                          disabled:
                                                            _vm.hasAccount,
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.lead
                                                              .email,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.lead,
                                                              "email",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.lead.email",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "signup_wizard.lead.email_hint"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2725181076
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("p", { staticClass: "text-muted mb-0" }, [
                                  _c(
                                    "small",
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "signup_wizard.lead.privacy_notice"
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: "/privacidade",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "signup_wizard.lead.privacy_link"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(". "),
                                    ],
                                    1
                                  ),
                                ]),
                                !_vm.token ? _c("recaptcha-notice") : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.current === "company"
                          ? _c(
                              "div",
                              { key: "step-company" },
                              [
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/2 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "CNPJ",
                                          vid: "cnpj",
                                          rules: "required|cnpj",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.company.cnpj"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value:
                                                              "##.###.###/####-##",
                                                            expression:
                                                              "'##.###.###/####-##'",
                                                          },
                                                        ],
                                                        attrs: {
                                                          inputmode: "numeric",
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.company
                                                              .cnpj,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.company,
                                                              "cnpj",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.company.cnpj",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1021634358
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/2 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.company.company_name"
                                          ),
                                          vid: "company_name",
                                          rules: "required|min:3",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.company.company_name"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.company
                                                              .company_name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.company,
                                                              "company_name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.company.company_name",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3706508263
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t(
                                      "signup_wizard.company.trading_name"
                                    ),
                                    vid: "trading_name",
                                    rules: "required|min:2",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "signup_wizard.company.trading_name"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    state: errors.length
                                                      ? false
                                                      : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.company
                                                        .trading_name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model.company,
                                                        "trading_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.company.trading_name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "signup_wizard.company.trading_name_hint"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-danger d-block",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3224385198
                                  ),
                                }),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t(
                                      "signup_wizard.company.description"
                                    ),
                                    vid: "description",
                                    rules: "required|min:10",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "signup_wizard.company.description"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("b-form-textarea", {
                                                  attrs: {
                                                    rows: "3",
                                                    state: errors.length
                                                      ? false
                                                      : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.company
                                                        .description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model.company,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.company.description",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "signup_wizard.company.description_hint"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-danger d-block",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4186653395
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.current === "person"
                          ? _c(
                              "div",
                              { key: "step-person" },
                              [
                                _c("h4", { staticClass: "mb-2" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.isEstablishment
                                          ? "signup_wizard.person.title_le"
                                          : "signup_wizard.person.title_ne"
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/2 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "CPF",
                                          vid: "cpf",
                                          rules: "required|cpf",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.person.cpf"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value:
                                                              "###.###.###-##",
                                                            expression:
                                                              "'###.###.###-##'",
                                                          },
                                                        ],
                                                        attrs: {
                                                          inputmode: "numeric",
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.person
                                                              .cpf,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.person,
                                                              "cpf",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.person.cpf",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3415650614
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/2 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.person.birthdate"
                                          ),
                                          vid: "birthdate",
                                          rules: "required|min_age",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.person.birthdate"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          type: "date",
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.person
                                                              .birthdate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.person,
                                                              "birthdate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.person.birthdate",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "signup_wizard.person.birthdate_hint"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4012090828
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t("signup_wizard.person.phone"),
                                    vid: "phone",
                                    rules: "required|min:14",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "signup_wizard.person.phone"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  directives: [
                                                    {
                                                      name: "mask",
                                                      rawName: "v-mask",
                                                      value: [
                                                        "(##) ####-####",
                                                        "(##) #####-####",
                                                      ],
                                                      expression:
                                                        "['(##) ####-####', '(##) #####-####']",
                                                    },
                                                  ],
                                                  attrs: {
                                                    inputmode: "tel",
                                                    state: errors.length
                                                      ? false
                                                      : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.person.phone,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model.person,
                                                        "phone",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.person.phone",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-danger d-block",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    297261664
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.current === "activity"
                          ? _c(
                              "div",
                              { key: "step-activity" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "signup_wizard.activity.modalities"
                                      ),
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "signup-pills" },
                                      _vm._l(
                                        _vm.modalities,
                                        function (modality) {
                                          return _c(
                                            "button",
                                            {
                                              key: modality.id,
                                              staticClass: "signup-pill",
                                              class: {
                                                "is-selected":
                                                  _vm.model.activity.modality_ids.includes(
                                                    modality.id
                                                  ),
                                              },
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleModality(
                                                    modality.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(modality.name) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signup_wizard.activity.modalities_hint"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                !_vm.isEstablishment
                                  ? [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.activity.display_name"
                                          ),
                                          vid: "display_name",
                                          rules: "required|min:3",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.activity.display_name"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.activity
                                                              .display_name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model
                                                                .activity,
                                                              "display_name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.activity.display_name",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "signup_wizard.activity.display_name_hint"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1992912477
                                        ),
                                      }),
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.activity.description"
                                          ),
                                          vid: "description",
                                          rules: "required|min:10",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.activity.description"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-textarea", {
                                                        attrs: {
                                                          rows: "3",
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.activity
                                                              .description,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model
                                                                .activity,
                                                              "description",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.activity.description",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "signup_wizard.activity.description_hint"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3153919193
                                        ),
                                      }),
                                    ]
                                  : _vm._e(),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        _vm.isEstablishment
                                          ? "signup_wizard.activity.serve_title_le"
                                          : "signup_wizard.activity.serve_title"
                                      ),
                                    },
                                  },
                                  [
                                    !_vm.isEstablishment
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.model.activity
                                                  .serves_in_person,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model.activity,
                                                  "serves_in_person",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.activity.serves_in_person",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "signup_wizard.activity.in_person"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        model: {
                                          value:
                                            _vm.model.activity.serves_at_home,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.activity,
                                              "serves_at_home",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "model.activity.serves_at_home",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "signup_wizard.activity.at_home"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        model: {
                                          value:
                                            _vm.model.activity.serves_online,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.activity,
                                              "serves_online",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "model.activity.serves_online",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "signup_wizard.activity.online"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    !_vm.isEstablishment && !_vm.anyServeMode
                                      ? _c(
                                          "small",
                                          {
                                            staticClass:
                                              "text-danger d-block mt-1",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "signup_wizard.activity.serve_title"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm.model.activity.serves_at_home
                                  ? _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "signup_wizard.activity.radius"
                                          ),
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          staticStyle: { "max-width": "10rem" },
                                          attrs: {
                                            type: "number",
                                            min: "1",
                                            max: "500",
                                          },
                                          model: {
                                            value:
                                              _vm.model.activity
                                                .service_radius_km,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.model.activity,
                                                "service_radius_km",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "model.activity.service_radius_km",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signup_wizard.activity.radius_hint"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm.current === "address"
                          ? _c(
                              "div",
                              { key: "step-address" },
                              [
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/3 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "CEP",
                                          vid: "postal_code",
                                          rules: "required|min:9",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.address.postal_code"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        directives: [
                                                          {
                                                            name: "mask",
                                                            rawName: "v-mask",
                                                            value: "#####-###",
                                                            expression:
                                                              "'#####-###'",
                                                          },
                                                        ],
                                                        attrs: {
                                                          inputmode: "numeric",
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        on: {
                                                          input: _vm.onCepInput,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.address
                                                              .postal_code,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.address,
                                                              "postal_code",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.address.postal_code",
                                                        },
                                                      }),
                                                      _vm.cepStatus ===
                                                      "searching"
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-muted",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "signup_wizard.address.searching"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm.cepStatus ===
                                                          "manual"
                                                        ? _c(
                                                            "small",
                                                            {
                                                              staticClass:
                                                                "text-warning",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "signup_wizard.address.not_found"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2598337852
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-2/3 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.address.street"
                                          ),
                                          vid: "street_name",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.address.street"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.address
                                                              .street_name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.address,
                                                              "street_name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.address.street_name",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2433439455
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c("div", { staticClass: "vx-row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-1/3 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.address.number"
                                          ),
                                          vid: "street_number",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.address.number"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        ref: "street_number",
                                                        attrs: {
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.address
                                                              .street_number,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.address,
                                                              "street_number",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.address.street_number",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2077199459
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-2/3 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "signup_wizard.address.district"
                                          ),
                                          vid: "district_name",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "signup_wizard.address.district"
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        attrs: {
                                                          state: errors.length
                                                            ? false
                                                            : null,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model.address
                                                              .district_name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model.address,
                                                              "district_name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.address.district_name",
                                                        },
                                                      }),
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-danger d-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(errors[0])
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3832535839
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "signup_wizard.address.city"
                                      ),
                                    },
                                  },
                                  [
                                    _vm.model.address.city_id
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "signup-city-selected",
                                          },
                                          [
                                            _c("feather-icon", {
                                              attrs: {
                                                icon: "MapPinIcon",
                                                svgClasses: "w-4 h-4",
                                              },
                                            }),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.model.address.city_label
                                                )
                                              ),
                                            ]),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "p-0 ml-1",
                                                attrs: {
                                                  size: "sm",
                                                  variant: "link",
                                                },
                                                on: { click: _vm.clearCity },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "signup_wizard.address.change_city"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : [
                                          _c("b-form-input", {
                                            attrs: {
                                              placeholder: _vm.$t(
                                                "signup_wizard.address.city_placeholder"
                                              ),
                                              autocomplete: "off",
                                            },
                                            model: {
                                              value: _vm.cityQuery,
                                              callback: function ($$v) {
                                                _vm.cityQuery = $$v
                                              },
                                              expression: "cityQuery",
                                            },
                                          }),
                                          _vm.cityOptions.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "signup-city-options",
                                                },
                                                _vm._l(
                                                  _vm.cityOptions,
                                                  function (city) {
                                                    return _c(
                                                      "button",
                                                      {
                                                        key: city.id,
                                                        staticClass:
                                                          "signup-city-option",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.pickCity(
                                                              city
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(city.name) +
                                                            "/" +
                                                            _vm._s(city.uf) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.current === "access"
                          ? _c(
                              "div",
                              { key: "step-access" },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t(
                                      "signup_wizard.access.password"
                                    ),
                                    vid: "password",
                                    rules: "required|min:8",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "signup_wizard.access.password"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "password",
                                                    autocomplete:
                                                      "new-password",
                                                    state: errors.length
                                                      ? false
                                                      : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.access.password,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model.access,
                                                        "password",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.access.password",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  { staticClass: "text-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "signup_wizard.access.policy"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm.model.access.password &&
                                                !_vm.passwordPolicyOk
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger d-block",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "signup_wizard.access.policy"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-danger d-block",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2910074767
                                  ),
                                }),
                                _c("validation-provider", {
                                  attrs: {
                                    name: _vm.$t(
                                      "signup_wizard.access.confirmation"
                                    ),
                                    vid: "password_confirmation",
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "signup_wizard.access.confirmation"
                                                  ),
                                                },
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "password",
                                                    autocomplete:
                                                      "new-password",
                                                    state: errors.length
                                                      ? false
                                                      : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.model.access
                                                        .password_confirmation,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.model.access,
                                                        "password_confirmation",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.access.password_confirmation",
                                                  },
                                                }),
                                                _vm.model.access
                                                  .password_confirmation &&
                                                !_vm.passwordsMatch
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger d-block",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "signup_wizard.access.mismatch"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-danger d-block",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1148725066
                                  ),
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.current === "review"
                          ? _c(
                              "div",
                              { key: "step-review" },
                              [
                                _c("h4", { staticClass: "mb-0" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("signup_wizard.review.title"))
                                  ),
                                ]),
                                _c("p", { staticClass: "text-muted mb-2" }, [
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("signup_wizard.review.subtitle")
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._l(_vm.summaryRows, function (row) {
                                  return _c(
                                    "div",
                                    {
                                      key: row.step,
                                      staticClass: "signup-summary-row",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "strong",
                                          { staticClass: "d-block" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signup_wizard.steps." +
                                                    row.step
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "small",
                                          { staticClass: "text-muted" },
                                          [_vm._v(_vm._s(row.text))]
                                        ),
                                      ]),
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "link",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.go(row.step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "signup_wizard.review.edit"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                _c(
                                  "div",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mb-1",
                                        model: {
                                          value: _vm.model.accepts.terms,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.accepts,
                                              "terms",
                                              $$v
                                            )
                                          },
                                          expression: "model.accepts.terms",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "signup_wizard.review.accept_terms_prefix"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/termos",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signup_wizard.review.accept_terms_link"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm.docs.terms
                                          ? _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "v" + _vm._s(_vm.docs.terms)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mb-1",
                                        model: {
                                          value: _vm.model.accepts.privacy,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model.accepts,
                                              "privacy",
                                              $$v
                                            )
                                          },
                                          expression: "model.accepts.privacy",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "signup_wizard.review.accept_privacy_prefix"
                                              )
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/privacidade",
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "signup_wizard.review.accept_privacy_link"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm.docs.privacy
                                          ? _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "v" + _vm._s(_vm.docs.privacy)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "w-full mt-2",
                                    attrs: {
                                      variant: "primary",
                                      disabled: !_vm.canSubmit || _vm.busy,
                                    },
                                    on: { click: _vm.submit },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.busy
                                            ? _vm.$t(
                                                "signup_wizard.review.submitting"
                                              )
                                            : _vm.$t(
                                                "signup_wizard.review.submit"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-muted text-center mt-1 mb-0",
                                  },
                                  [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.hasAccount
                                            ? _vm.$t(
                                                "signup_wizard.review.note_account"
                                              )
                                            : _vm.$t(
                                                "signup_wizard.review.note"
                                              )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }